/**
 * "Is this campaign allowed to send?" — one rule, shared.
 *
 * The wizard gates every step on it, activateCampaign() refuses without it, and
 * the end-to-end harness asserts against it. Keeping it here (pure, no client)
 * means the UI can never be more permissive than the check that actually
 * guards the commit.
 */

export type MissingPiece = 'campaign' | 'identity' | 'leads' | 'template'

export interface ReadinessInput {
  /** the campaign row, or null when it never saved */
  campaign: { id: string } | null
  /** the campaign's bound template, resolved and proven to still exist */
  template: { id: string } | null
  /** leads persisted to THIS campaign, counted on the server */
  leadCount: number
  /** the identity that would actually send: the campaign's, else the default */
  identity: { id: string } | null
}

/** Everything standing between this campaign and a legitimate send. */
export function missingPieces(input: ReadinessInput): MissingPiece[] {
  const missing: MissingPiece[] = []
  if (!input.campaign) missing.push('campaign')
  if (!input.identity) missing.push('identity')
  if (input.leadCount <= 0) missing.push('leads')
  if (!input.template) missing.push('template')
  return missing
}

export function isReady(input: ReadinessInput): boolean {
  return missingPieces(input).length === 0
}

/** What to tell the user, and which wizard step owns the fix. */
export const MISSING_LABEL: Record<MissingPiece, string> = {
  campaign: 'the campaign was never saved',
  identity: 'no sending identity',
  leads: 'no leads on this campaign',
  template: 'no template bound',
}
